module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "Home",
    attrs: {
      "scrollbar": ""
    }
  }, [_c('div', {
    staticClass: "Home-content"
  }, [_c('section', {
    staticClass: "Projects",
    attrs: {
      "id": "projects"
    }
  }, [_c('h1', {
    staticClass: "Projects-title"
  }, [_vm._v("Projets")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "Projects-works"
  }, _vm._l((_vm.works), function(work, index) {
    return _c('article', {
      staticClass: "Projects-article",
      attrs: {
        "data-aos": "fade-up",
        "data-aos-delay": index % 2 ? 200 : 0
      }
    }, [_c('figure', {
      staticClass: "Projects-fig"
    }, [_c('img', {
      attrs: {
        "src": work.src,
        "alt": work.caption
      }
    }), _vm._v(" "), _c('figcaption', [_c('h2', [_vm._v(_vm._s(work.caption))])]), _vm._v(" "), _c('router-link', {
      staticClass: "routerlink",
      attrs: {
        "to": work.path
      }
    }, [_vm._v(_vm._s(work.caption))])], 1)])
  }), 0)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('section', {
    staticClass: "Contact",
    attrs: {
      "id": "contact"
    }
  }, [_c('div', {
    staticClass: "Contact-inner"
  }, [_vm._m(2), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade",
      "data-aos-delay": "200"
    }
  }, [_vm._v("Si vous préférez les réseaux sociaux, j'y suis très active !")]), _vm._v(" "), _c('div', {
    staticClass: "Contact-social"
  }, [_c('a', {
    attrs: {
      "href": "https://www.instagram.com/misu_fany/",
      "target": "_blank",
      "rel": "noopener",
      "data-aos": "fade-up",
      "data-aos-delay": "300",
      "title": "Instagram"
    }
  }, [_c('svg', {
    staticClass: "instagram"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-instagram"
    }
  })])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://twitter.com/misufany",
      "target": "_blank",
      "rel": "noopener",
      "title": "Twitter",
      "data-aos": "fade-up",
      "data-aos-delay": "400"
    }
  }, [_c('svg', {
    staticClass: "twitter"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-twitter"
    }
  })])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.malt.fr/profile/fanyrighi",
      "target": "_blank",
      "rel": "noopener",
      "data-aos": "fade-up",
      "data-aos-delay": "500",
      "title": "Malt"
    }
  }, [_c('svg', {
    staticClass: "malt"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-malt"
    }
  })])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.linkedin.com/in/fanyrighi/",
      "target": "_blank",
      "rel": "noopener",
      "data-aos": "fade-up",
      "data-aos-delay": "600",
      "title": "Linkedin"
    }
  }, [_c('svg', {
    staticClass: "linkedin"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-linkedin"
    }
  })])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.artstation.com/misufany",
      "target": "_blank",
      "rel": "noopener",
      "data-aos": "fade-up",
      "data-aos-delay": "700",
      "title": "ArtStation"
    }
  }, [_c('svg', {
    staticClass: "artstation"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-artstation"
    }
  })])])])])]), _vm._v(" "), _c('footer', {
    staticClass: "Footer"
  }, [_c('div', {
    staticClass: "Footer-inner"
  }, [_c('p', {
    staticClass: "Footer-rights"
  }, [_vm._v("© " + _vm._s(new Date().getFullYear()) + " Fany Righi. Tous droits réservés.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Home-bg"
  }, [_c('img', {
    staticClass: "Home-singleBg",
    attrs: {
      "src": _vm.fanySingle,
      "alt": "Dessin de Fany Righi"
    }
  })])]), _vm._v(" "), _c('figure', {
    staticClass: "Landing"
  }, [_c('img', {
    staticClass: "Landing-bg",
    attrs: {
      "alt": "Arrière plan",
      "src": _vm.landingBg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Menu",
    class: {
      open: _vm.menuIsOpen
    }
  }, [_c('nav', {
    staticClass: "Menu-desktopNav"
  }, [_c('a', {
    attrs: {
      "href": "#projects"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.jumpTo.apply(null, arguments)
      }
    }
  }, [_vm._v("Portfolio")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#about"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.jumpTo.apply(null, arguments)
      }
    }
  }, [_vm._v("A propos")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#contact"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.jumpTo.apply(null, arguments)
      }
    }
  }, [_vm._v("Contact")])]), _vm._v(" "), _c('div', {
    staticClass: "Menu-mobile"
  }, [_c('nav', {
    staticClass: "Menu-mobileNav"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#projects"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.jumpTo.apply(null, arguments)
      }
    }
  }, [_vm._v("Projets")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#about"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.jumpTo.apply(null, arguments)
      }
    }
  }, [_vm._v("A propos")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#contact"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.jumpTo.apply(null, arguments)
      }
    }
  }, [_vm._v("Contact")])])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "Menu-social"
  }, [_c('a', {
    attrs: {
      "href": "https://www.instagram.com/misu_fany/",
      "target": "_blank",
      "rel": "noopener",
      "title": "Instagram"
    }
  }, [_c('svg', {
    staticClass: "instagram"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-instagram"
    }
  })])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://twitter.com/misufany",
      "target": "_blank",
      "rel": "noopener",
      "title": "Twitter"
    }
  }, [_c('svg', {
    staticClass: "twitter"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-twitter"
    }
  })])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.malt.fr/profile/fanyrighi",
      "target": "_blank",
      "rel": "noopener",
      "title": "Malt"
    }
  }, [_c('svg', {
    staticClass: "malt"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-malt"
    }
  })])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.linkedin.com/in/fanyrighi/",
      "target": "_blank",
      "rel": "noopener",
      "title": "Linkedin"
    }
  }, [_c('svg', {
    staticClass: "linkedin"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-linkedin"
    }
  })])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.artstation.com/misufany",
      "target": "_blank",
      "rel": "noopener",
      "title": "ArtStation"
    }
  }, [_c('svg', {
    staticClass: "artstation"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-artstation"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "Menu-btn"
  }, [_c('div', {
    staticClass: "Menu-icon",
    on: {
      "click": function($event) {
        _vm.menuIsOpen = !_vm.menuIsOpen
      }
    }
  }, [_c('span'), _c('span'), _c('span'), _c('span'), _c('span'), _c('span')])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "Projects-subtitle"
  }, [_vm._v("Voici quelques projets réalisés avec passion."), _c('br'), _vm._v("Et si on travaillait ensemble ?")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "About",
    attrs: {
      "id": "about"
    }
  }, [_c('h1', {
    attrs: {
      "data-aos": "fade",
      "data-aos-delay": "200"
    }
  }, [_vm._v("à propos")]), _vm._v(" "), _c('div', {
    staticClass: "About-text"
  }, [_c('p', {
    attrs: {
      "data-aos": "fade",
      "data-aos-delay": "300"
    }
  }, [_vm._v("\n          Originaire du plat pays qui est le mien, j'ai suivi une formation en Webdesign-UI-UX et travaillé en agence à Paris avant de m'installer à Nantes en tant que freelance. Je combine la bonne humeur et la rigueur avec brio et m'inspire de tout ce qui m’entoure."), _c('br'), _c('br'), _vm._v("\n          J'attache une grande importance à la réflexion avant de m’attaquer à un projet. J'aime mettre en avant l'ergonomie tout en respectant les tendances graphiques actuelles.\n        ")]), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade",
      "data-aos-delay": "400"
    }
  }, [_vm._v("\n          Je passe un temps certain à faire de la veille, un benchmark et un moodboard. J'envoie toujours plusieurs pistes à mes clients afin d'établir ensemble quelle direction prendre et ne pas perdre de temps sur un travail qui risque de ne pas leur plaire."), _c('br'), _c('br'), _vm._v("\n          Mes domaines de prédilection sont le webdesign et le graphisme web. N'hésitez pas à me contacter afin de vérifier si ce que vous souhaitez rentre dans mes cordes. Je m'occuperai de votre projet avec beaucoup d'attention et vous guiderai si besoin.\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Contact-text"
  }, [_c('h1', {
    attrs: {
      "data-aos": "fade",
      "data-aos-delay": "200"
    }
  }, [_vm._v("Contact")]), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade",
      "data-aos-delay": "300"
    }
  }, [_vm._v("Si vous souhaitez me rencontrer ou en savoir plus,"), _c('br'), _vm._v("c'est par ici : "), _c('a', {
    staticClass: "trans",
    attrs: {
      "href": "mailto:fanyrighi@gmail.com"
    }
  }, [_vm._v("fanyrighi@gmail.com")])]), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade",
      "data-aos-delay": "400"
    }
  }, [_vm._v("Vous pouvez également me contacter via la plateforme de freelances sécurisée : "), _c('a', {
    staticClass: "trans",
    attrs: {
      "target": "_blank",
      "rel": "noopener",
      "href": "https://www.malt.fr/profile/fanyrighi"
    }
  }, [_vm._v("Malt (ex-Hopwork)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Menu-email"
  }, [_c('a', {
    staticClass: "white trans",
    attrs: {
      "href": "mailto:fanyrighi@gmail.com"
    }
  }, [_vm._v("fanyrighi@gmail.com")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33658cc4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 214
// module chunks = 0